(function () {
    angular
        .module("app")
        .service("SearchService", SearchService);

    function SearchService() {


        var svc = {};
        window._searchService = svc;

        svc.loadPropsAndMethods = function(callerScope){


            //----------------------------------------------
            //  Search for one ArcGIS searchView / bucket
            //----------------------------------------------
            const doArcGISSearch = (viewIndex = 0) => {

                return (
                    new Promise((resolve, reject) => {

                        const useInfer = true; // arcgis search extension
                        const searchTerm = callerScope.searchTerm.trim();
                        const arcgisSearchExtension = callerScope.arcgisSearchExtensionParams(searchTerm,true,true);
                        const query = arcgisSearchExtension.query;

                        // start position: item at top of results list
                        const startPosition = callerScope.currentSearch.startRecord;
                        //const startPosition = (callerScope.currentSearch.searchResults.filter( oneRecord => viewIndex == oneRecord.searchViewIndex )).length;

                        const viewInfo = callerScope.getBucketCollectionData("arcgis.esri.com");
                        const searchApiUrl = "//www.arcgis.com/sharing/rest/search";

                        const paramsArcgisDotCom = {
                            f: 'json',
                            start: startPosition,
                            num: callerScope.currentSearch.fetchSize, //showOnePage
                            q: query,
                            sortOrder: arcgisSearchExtension.sortOrder, //,`desc`, //
                            sortField: arcgisSearchExtension.sortField  //`modified`, //
                        };

                        const paramsLivingAtlas = {
                            f: 'json',
                            start: startPosition,
                            num: callerScope.currentSearch.fetchSize, //showOnePage
                            q: `(group:"47dd57c9a59d458c86d3d6b978560088")${query}`,
                            sortOrder: arcgisSearchExtension.sortOrder, //,`desc`, //
                            sortField: arcgisSearchExtension.sortField  //`modified`, //
                        };


                        function getAGOLSearchDetails(params){
                            return new Promise((resolve, reject) => {

                                  $.ajax({
                                  url: searchApiUrl,
                                  data: params.searchParams, // paramsLivingAtlas,
                                  dataType: 'json',
                                  success: function (data) {

                                      if(data.error){
                                          window._error = {
                                              position: 62,
                                              msg: data.error.message,
                                              viewIndex: viewIndex,
                                              view: callerScope.buckets[viewIndex]
                                          };
                                          reject({type:'error',data:window._error,success:false})
                                      }

                                      const r = data.results;
                                      let arrLivingAtlasIds = [];
                                      for (let i = 0; i < r.length; i++) {
                                          arrLivingAtlasIds.push(r[i].id)
                                      }

                                      resolve({type:'success',data:data,params:params,success:true})

                                  },
                                  error: function (e, msg) {

                                      window._error = {
                                          position: 2,
                                          e: e,
                                          msg: msg + " (living atlas)",
                                          viewIndex: viewIndex,
                                          view: callerScope.buckets[viewIndex]
                                      };
                                      reject({type:'error',data:window._error,success:false})

                                  }
                              });

                            })
                        }


                        getAGOLSearchDetails(
                          {
                              arcgis:{},
                              livingAtlas:{},
                              searchParams:paramsLivingAtlas
                          }
                        ).then(function(details) {
                            const r = details.data.results;
                            let ids = [];
                            for (let i = 0; i < r.length; i++) {
                                ids.push(r[i].id)
                            }
                            details.params.livingAtlas = {ids:ids,total:details.data.total};
                            details.params.searchParams = {
                                f: 'json',
                                q: query,
                                sortOrder: arcgisSearchExtension.sortOrder, //,`desc`,
                                sortField: arcgisSearchExtension.sortField,  //`modified`,
                                start: 1, //startPosition,
                                num: callerScope.currentSearch.fetchSize+details.data.total+1 //showOnePage
                            };

                            return getAGOLSearchDetails(details.params);
                        }).then((details) => {
                            details.params.arcgis.total = details.data.total;
                            details.params.arcgis.data = details.data;

                            return searchArcgisDotCom(details.params);
                        });

                function searchArcgisDotCom(params){


                    const arrLivingAtlasIds = params.livingAtlas.ids;
                    const livingAtlasTotal = params.livingAtlas.total;
                    const arcgisTotal = params.arcgis.total;


                    // adjust for missing Living Atlas duplicates
                    paramsArcgisDotCom.start = (callerScope.currentSearch.currentPage-1)*callerScope.currentSearch.fetchSize+1;
                    // get additional results to compensate for removing Living Atlas duplicates
                    paramsArcgisDotCom.num = callerScope.currentSearch.fetchSize+livingAtlasTotal+1;

                    const searchParams = livingAtlasTotal>=paramsLivingAtlas.start ? paramsLivingAtlas : paramsArcgisDotCom;

                    window._searchArcgisDotCom = {
                        arrLivingAtlasIds:arrLivingAtlasIds,
                        livingAtlasTotal:livingAtlasTotal,
                        arcgisTotal:arcgisTotal,
                        paramsArcgisDotComStart:paramsArcgisDotCom.start,
                        paramsArcgisDotComNum: paramsArcgisDotCom.num,
                        paramsLivingAtlas:paramsLivingAtlas,
                        paramsArcgisDotCom:paramsArcgisDotCom
                    }


                    getAGOLSearchDetails(
                      {
                          arcgis:{},
                          livingAtlas:{},
                          searchParams:searchParams
                      }
                    ).then(function(details) {
                        const diff = details.data.num-details.data.results.length;
                        const isLivingAtlas = !!searchParams.q.match(/47dd57c9a59d458c86d3d6b978560088/) ? true : false;

                        // if isLivingAtlas==true
                        // subset
                        // details.data.results: search results is from Living Atlas only - curated subset of arcgis.com database
                        // otherwise
                        // superset
                        // details.data.results: search results is from arcgis.com

                        // for completing results array when Living Atlas query returns less that the full number requested (num)
                        // params.arcgis.data.results: search results always from arcgis.com - everything from arcgis.com database including Living Atlas

                        // for tracking query

                        window._check_agol_results = [];
                        if(!!diff && isLivingAtlas) {
                            for (let i = 0; i < details.data.results.length; i++) {
                                window._check_agol_results.push({
                                    type: "Living Atlas only",
                                    index: i,
                                    title: details.data.results[i].title,
                                    result: details.data.results[i]
                                });
                            }
                        }
                        for(let i=0 ; i<params.arcgis.data.results.length ; i++){
                            const checkId = arrLivingAtlasIds.find(item => {
                                return item == params.arcgis.data.results[i].id;
                            })
                            window._check_agol_results.push({
                                type:"AG Online (all)",
                                index:i,
                                title:params.arcgis.data.results[i].title,
                                isInLivingAtlas:!!checkId,
                                result:params.arcgis.data.results[i]
                            });
                        }
                        window._check_agol_results.push({
                            params:params,
                            diff:diff,
                            arrLivingAtlasIds:arrLivingAtlasIds,
                            paramsArcgisDotCom:paramsArcgisDotCom,
                            paramsLivingAtlas:paramsLivingAtlas

                        });

                        // if total results returned from living Atlas query (details.data.results.length)
                        // is less that num (=requested number of results to return (diff>0),
                        // append from arcgis.com results (params.arcgis.data.results)

                        if(!!diff && isLivingAtlas){
                            let check = 0;
                            let addCount = 0;
                            let i = 0;

                            while(check<100 && addCount < diff && i <  params.arcgis.data.results.length){

                                if(
                                  !arrLivingAtlasIds.find(item => {
                                     // skip records
                                      return item == params.arcgis.data.results[i].id;})
                                ){
                                    details.data.results.push(params.arcgis.data.results[i]);
                                    addCount++;
                                }
                                i++;
                                check++;
                            }
                            details.data.total = arcgisTotal;
                            details.data.nextStart = i;
                            callerScope.arcgisDotComAltNextStart = i;

                        } // end if()

                        // when there are no results from Living Atlas
                        if(!isLivingAtlas){
                            let check = 0;
                            let addCount = 0;
                            let i = 0;
                            let newResults = [];

                            while(check<4000 && addCount < callerScope.currentSearch.fetchSize && i < details.data.num){
                                if(
                                  !arrLivingAtlasIds.find(item => {
                                      return item == details.data.results[i].id;})
                            ){
                                    if(details.data.results[i]){
                                        newResults.push(details.data.results[i]);
                                        i++;
                                        addCount++;
                                    }
                                }
                                check++;
                            }
                            details.data.results = newResults;
                            details.data.total = arcgisTotal;
                            details.data.nextStart = details.data.start+i;
                            callerScope.arcgisDotComAltNextStart = details.data.nextStart;
                        }

                        const results = processSearchData(details.data, params, searchParams);
                        callerScope.buckets[viewIndex].searchResults = results;
                        callerScope.buckets[viewIndex].resultsCount = arcgisTotal;
                        resolve({viewIndex: viewIndex})

                    }); //end .then()
                } // searchArcgisDotCom()
    
    


                    const dateDiff = {

                        days: function(d1, d2) {
                            var t2 = d2.getTime();
                            var t1 = d1.getTime();

                            return parseInt((t2-t1)/(24*3600*1000));
                        },

                        weeks: function(d1, d2) {
                            var t2 = d2.getTime();
                            var t1 = d1.getTime();

                            return parseInt((t2-t1)/(24*3600*1000*7));
                        },

                        months: function(d1, d2) {
                            var d1Y = d1.getFullYear();
                            var d2Y = d2.getFullYear();
                            var d1M = d1.getMonth();
                            var d2M = d2.getMonth();

                            return (d2M+12*d2Y)-(d1M+12*d1Y);
                        },

                        years: function(d1, d2) {
                            return d2.getFullYear()-d1.getFullYear();
                        }
                    };


                    function setArcgisResultRank(_isLivingAtlas,_mDate){
                        const _now = new Date();
                        const monthDiff = dateDiff.months(_mDate,_now);
                        const yearDiff = dateDiff.years(_mDate,_now);
                        let rank = _isLivingAtlas ? laRank() : agisRank();


                        function laRank(){
                            let _rank = 10;
                            if(monthDiff > 2) _rank-=1;
                            if(monthDiff > 3) _rank-=1;
                            if(monthDiff > 6) _rank-=2;
                            if(yearDiff > 0) _rank-=2;
                            if(yearDiff > 2) _rank-=1;
                            if(yearDiff > 5) _rank-=1;
                            return _rank
                        }

                        function agisRank(){
                            let _rank = 4;
                            if(monthDiff > 2) _rank-=1;
                            if(monthDiff > 3) _rank-=1;
                            if(monthDiff > 9) _rank-=1;
                            if(yearDiff > 0) _rank-=1;
                            return _rank
                        }

                        return rank;
                    }

    
                    function processSearchData(data,params,searchParams){
    
                        const arrLivingAtlasIds = params.livingAtlas.ids;
                        const livingAtlasTotal = params.livingAtlas.total;
                        const arcgisTotal = params.arcgis.total;
    
                        const _testing = false;
                        const itemsRootUrl = "//www.arcgis.com/sharing/rest/content/items/";
                        const webmapRootUrl = "//www.arcgis.com/home/webmap/viewer.html?layers=";
                        const mainItemRootUrl = "//www.arcgis.com/home/item.html?id=";
    
                        const results = data.results.map((r,i,a) => {
                              let tn = r.thumbnail || '';
                        if(r.largeThumbnail && r.largeThumbnail.length){
                            tn = r.largeThumbnail;
                        }
                        const tnUrl = tn.length ? `${itemsRootUrl}${r.id}/info/${tn}` : '';
                        const wmUrl = `${webmapRootUrl}${r.id}&useExisting=1`;
                        const mainUrl = `${mainItemRootUrl}${r.id}`;
                        const _mDate = new Date(r.modified);
                        const  _monthNames = ["January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                        ];
                        const mDate = `${_monthNames[_mDate.getMonth()]} ${_mDate.getDate()}, ${_mDate.getFullYear()}`;
                        const isLivingAtlas = !!arrLivingAtlasIds.find(item => {
                              return item == r.id;});
                        let _title = r.title;
                        // if(_testing && isLivingAtlas){
                        //     _title += ` (living atlas total ${livingAtlasTotal})`
                        // }
    
                        const rank = setArcgisResultRank(isLivingAtlas,_mDate,r);


                        return {
                            // arcgis
                            id: r.id,
                            thumbnail: tn,
                            thumbnailUrl: tnUrl,
                            livingatlas: isLivingAtlas,
                            webmapUrl: wmUrl,
                            mainItemUrl: mainUrl,
                            snippet: r.snippet,
                            type: r.type,
                            owner: r.owner,
                            modified: r.modified,
                            mDate: mDate,
                            numComments: r.numComments,
                            numRatings: r.numRatings,
                            avgRating: r.avgRating,
                            numViews: r.numViews,
                            
                            // all
                            searchViewIndex:viewIndex,
                            searchView:callerScope.buckets[viewIndex].name,
                            searchType:callerScope.buckets[viewIndex].type,
                            searchDisplay:callerScope.buckets[viewIndex].display,
                            collectionCategory:viewInfo.collectionCategory,
                            title: _title, // r.title,
                            summary: r.description || '',
                            url: r.url || '',
                            rank: rank, // (10).toString(),
                            language: 'en',
                            ordinal: searchParams.start+i, // '1',
                            isChild: false,
                            moreResultsFromUrl: ''
                        }
                    });
                        return results;
                    } // processSearchData(data){
    
                    
                    
                    })
                )
            };
            // End doArcGISSearch()


            //----------------------------------------------
            //  Search for one GSA searchView / bucket
            //----------------------------------------------
            const doGsaSearch = (viewIndex = 0) => {
                return (
                    new Promise((resolve, reject) => {

                        const startPosition = callerScope.currentSearch.startRecord;
                        // start searching after previous search index
                        // const startPosition = (callerScope.currentSearch.searchResults.filter(oneRecord => {
                        //     return oneRecord.searchViewIndex == viewIndex;
                        // })).length;





                        // fix for GSA changing total search hit count and possibly retrieving extra records
                        const fetchSize = callerScope.buckets[viewIndex].resultsCount == startPosition && startPosition > 0
                                ? 0 : callerScope.currentSearch.fetchSize;

                        const params = {
                            interfaceName:callerScope.buckets[viewIndex].interfaceName,
                            searchViewName:callerScope.buckets[viewIndex].searchViewName,
                            format: 'jsonp',
                            q: callerScope.searchGsaQuery,
                            oe: 'utf8',
                            filter: 1,
                            ie: 'utf8',
                            lr: 'en',
                            start: startPosition,
                            num: fetchSize
                        };
                        window._searchParams = params;
                        window._check_gsa_search = {apiUrl:callerScope.apiUrl,params:params}
                        $.ajax({
                            url: callerScope.apiUrl,
                            data: params,
                            dataType: 'jsonp',
                            success: function (data) {
                                if (data.hasError) {
                                    window._error = {
                                        position:1,
                                        location:'doGsaSearch:success',
                                        apiUrl:callerScope.apiUrl,
                                        msg:data.errorMessage,
                                        viewIndex:viewIndex,
                                        view:callerScope.buckets[viewIndex]
                                    };
                                    reject(window._error);

                                } else {
                                    callerScope.buckets[viewIndex].searchXmlResults = data.content;
                                    var results = processSearchResults(data.content,viewIndex);
                                    callerScope.buckets[viewIndex].searchResults = results;

                                    var popularResults = processPopularResults(data.content,viewIndex);
                                    callerScope.buckets[viewIndex].popularResults = popularResults;
                                    callerScope.currentSearch.popularResults = popularResults;
                                    //console.log('buckets[viewIndex]["popularResults"] ',callerScope.buckets[viewIndex]["popularResults"])

                                    callerScope.buckets[viewIndex].searchParams = params;
                                    window._searchResults = results;
                                    window._searchData = data;
                                    resolve({viewIndex:viewIndex})

                                }
                            },
                            error: function (e, msg) {
                                window._error = {
                                    position:2,
                                    location:'doGsaSearch:error',
                                    apiUrl:callerScope.apiUrl,
                                    e:e,
                                    msg:msg,
                                    viewIndex:viewIndex,
                                    view:callerScope.buckets[viewIndex]
                                };
                                reject(window._error);
                            }
                        });
                    })
                )
            }; // doGsaSearch

            //----------------------------------------------
            //  Process GSA popular results
            //----------------------------------------------
            const processPopularResults = (xmlResults, viewIndex = -1) => {
                
                    const x2js = new X2JS();
                    const jsonResults = x2js.xml_str2json(xmlResults);
                    // popular results: jsonResults.GSP

    
                    // Popular Results
                    const popResults = [];
                    if (jsonResults.GSP && jsonResults.GSP.GM) {
                        if (typeof jsonResults.GSP.GM.GD == 'undefined') {
                    //         popResults = _.map(jsonResults.GSP.GM, function(popResult) {
                    //             return {
                    //                 title: popResult.GD,
                    //                 url: popResult.GL
                    //             }
                    //         });
                        } else {
                            popResults.push({
                                title: jsonResults.GSP.GM.GD,
                                url: jsonResults.GSP.GM.GL,
                                description: jsonResults.GSP.GM.GS
                            });
                        }
                    }
                    return popResults;
                }                   
            //----------------------------------------------
            //  Process GSA search results
            //----------------------------------------------
            const processSearchResults = (xmlResults, viewIndex = -1) => {

                const x2js = new X2JS();
                const jsonResults = x2js.xml_str2json(xmlResults);

                //Search Results
                if (jsonResults.GSP && jsonResults.GSP.RES && jsonResults.GSP.RES.R) {

                    let results;
                    let resultSet;

                    if(!Array.isArray(jsonResults.GSP.RES.R)){
                        resultSet = [
                            jsonResults.GSP.RES.R
                        ]
                    }
                    else
                    {
                        resultSet = jsonResults.GSP.RES.R;
                    }

                    results = resultSet.map(function(rawResult) {
                        const viewInfo = callerScope.getBucketCollectionData(rawResult.U);
                        return {
                            // arcgis
                            thumbnail:'',
                            thumbnailUrl:'',
                            id:'',
                            webmapUrl: '',
                            mainItemUrl: '',
                            snippet: '',
                            owner: '',
                            modified: '',
                            mDate: '',
                            numComments: '',
                            numRatings: '',
                            avgRating: '',
                            numViews: '',
                            type: '',

                            // all
                            searchViewIndex:viewIndex,
                            searchView:callerScope.buckets[viewIndex].name,
                            searchType:callerScope.buckets[viewIndex].type,
                            searchDisplay:callerScope.buckets[viewIndex].display,
                            collectionCategory:viewInfo.collectionCategory,
                            title: rawResult.T,
                            summary: rawResult.S,
                            url: rawResult.U,
                            rank: rawResult.RK,
                            language: rawResult.LANG,
                            ordinal: rawResult._N,
                            isChild: rawResult._L != null,
                            moreResultsFromUrl: rawResult.HN != null ? rawResult.HN._U : ''
                        };
                    });

                    if(viewIndex > -1){
                        callerScope.buckets[viewIndex].resultsCount = jsonResults.GSP.RES.M;
                    }
                    return results;
                }
                return [];
            }; // END processSearchResults


            //----------------------------------------------
            //  Aggregate (one or more) search results set(s)
            //  into callerScope.currentSearch.searchResults
            //----------------------------------------------
            callerScope.aggregateResults = () => {

                const fetchSize = callerScope.currentSearch.fetchSize;
                const viewIndices = callerScope.views;
                const tempData = [];
                let tempResults = [];
                let results = [];
                let resultsCount = 0;

                tempData[0] = callerScope.buckets[viewIndices[0]].searchResults;
                resultsCount += parseInt(callerScope.buckets[viewIndices[0]].resultsCount);

                for( let i=1 ; i<viewIndices.length ; i++){
                    tempData[i] = tempData[i-1].concat(callerScope.buckets[viewIndices[i]].searchResults)
                    resultsCount += parseInt(callerScope.buckets[viewIndices[i]].resultsCount);
                }

                // sort aggregated results
                if( tempData.length > 1){
                    tempResults = tempData[tempData.length-1].sort(function(a,b){
                        if(a.rank == b.rank){
                            return parseInt(a.ordinal) - parseInt(b.ordinal);
                        }
                        else{
                            // descending order
                            return parseInt(b.rank) - parseInt(a.rank);
                        }
                    });
                }
                else{
                    tempResults = tempData[0];
                }

                if(fetchSize < tempResults.length){
                    results = tempResults.slice(0,fetchSize);
                }
                else{
                    results = tempResults;
                }


                callerScope.currentSearch.searchResults = [];
                callerScope.currentSearch.searchResults = callerScope.currentSearch.searchResults.concat(results);
                callerScope.currentSearch.resultsCount = resultsCount;

                for( let i = 0 ; i<callerScope.currentSearch.searchResults.length ; i++){
                    callerScope.currentSearch.searchResults[i].index = i;
                }

            } // End callerScope.aggregateResults



            //----------------------------------------------
            //  Do all searchView / bucket promises
            //----------------------------------------------
            const doSearchViews = (searchViewPromises) => {
                callerScope.currentSearch.shroud = true;
                return (
                    Promise.all(searchViewPromises).then(
                        (resolve) => {
                            if(typeof callerScope.onSearchComplete == 'function'){
                                callerScope.onSearchComplete({type:'success',content:resolve,success:true})
                            }
                        },
                        (error) => {
                            error.msg = error.msg || 'no error message (doSearchViews)';

                            if(typeof callerScope.onSearchComplete == 'function'){
                                callerScope.onSearchComplete({type:'error',content:error,success:false})
                            }
                            callerScope.currentSearch.shroud = false;             
                        }
                    )
                )
            }; // End doSearchViews


            //----------------------------------------------
            //  Begin search process
            //----------------------------------------------
            callerScope.performSearch = () => { // onSetPage
                let searchViewPromises = [];
                for( let i = 0 ; i < callerScope.views.length ; i++){
                    const _type = callerScope.buckets[callerScope.views[i]].type.toLowerCase() || "";

                    if(_type == 'arcgis'){
                        searchViewPromises.push(doArcGISSearch(callerScope.views[i]))
                    }
                    else if(_type == 'gsa'){
                        searchViewPromises.push(doGsaSearch(callerScope.views[i]))
                    }
                }
                doSearchViews(searchViewPromises)
            }; // End callerScope.performSearch

        };
        return svc;
    }

})();
